import type { DashboardOrderDetail } from '../types/dashboard.types'

interface OrderInfoStripProps {
  order: DashboardOrderDetail
}

interface InfoChip {
  label: string
  value: string | null
  href?: string
}

export function OrderInfoStrip({ order }: OrderInfoStripProps) {
  const chips: InfoChip[] = [
    { label: 'Kunde', value: order.customer_name },
    { label: 'Merking', value: order.reference },
    {
      label: 'Tlf',
      value: order.customer_phone,
      href: order.customer_phone ? `tel:${order.customer_phone}` : undefined,
    },
    { label: 'Ref', value: order.your_ref },
    { label: 'Eier', value: order.order_owner_customer_name },
  ].filter((chip) => chip.value)

  if (chips.length === 0) return null

  return (
    <div className="px-6 py-3 border-b border-gray-200 bg-gray-50">
      <div className="flex flex-wrap gap-x-6 gap-y-1">
        {chips.map((chip) => (
          <div key={chip.label} className="inline-flex items-center gap-1 text-[13px] py-0.5">
            <span className="text-gray-400">{chip.label}</span>
            {chip.href ? (
              <a href={chip.href} className="font-medium text-emerald-600 hover:underline">
                {chip.value}
              </a>
            ) : (
              <span className="font-medium text-gray-900">{chip.value}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
